/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
jQuery(($) => {
    $('.wp-block-stratos-blocks-stratos-acc-item-header').on('click', function () {

        const $header = $(this)
        const $item = $header.parent()
        const $parent = $item.parent()
        const $body = $item.find('.wp-block-stratos-blocks-stratos-acc-item-body')

        const isActive = $item.hasClass('active')

        // Close all items
        $parent.find('.wp-block-stratos-blocks-stratos-acc-item').removeClass('active')
            .find('.wp-block-stratos-blocks-stratos-acc-item-body').stop(true, true).slideUp()

        // If the clicked one wasn't already open, open it
        if (!isActive) {
            $item.addClass('active')
            $body.stop(true, true).slideDown()
        }
    })
})



/* eslint-enable no-console */
